import React, { Component } from 'react';
import { array, arrayOf, bool, func, object, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { getAgeRange } from '../../util/ageUtils';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import AuthenticationPage from '../AuthenticationPage/AuthenticationPage';
import { AiFillStar } from 'react-icons/ai';
import { FaBirthdayCake } from 'react-icons/fa';
import { loginModalDispatch } from '../../ducks/Auth.duck';
import { timestampToDate, calculateQuantityFromHours } from '../../util/dates';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import { initiateOrder } from '../CheckoutPage/CheckoutPage.duck';
import {
  Page,
  Modal,
  NamedLink,
  NamedRedirect,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  BookingPanel,
} from '../../components';
import { EnquiryForm } from '../../forms';
import { TopbarContainer, NotFoundPage } from '../../containers';

import { isEnquiriesPaused } from '../../util/enquiries';
import {
  sendEnquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
  fetchFastReplyListings,
  fetchHasBookedProvider,
} from './ListingPage.duck';
import { FAST_REPLY_TESTERS, pickFastReplyTesters } from './fastReplyTesters';
import {
  pausedEnquiryMessage,
  rememberPausedEnquirySent,
  wasPausedEnquirySent,
} from './pausedEnquiry';
import SectionEnquiriesPaused from './SectionEnquiriesPaused';
import SectionImages from './SectionImages';
import SectionAvatar from './SectionAvatar';
import SectionHeading from './SectionHeading';
import SectionPhotosMaybe from './SectionPhotosMaybe';

import SectionPricingMaybe from './SectionPricingMaybe';
import SectionDescriptionMaybe from './SectionDescriptionMaybe';
import SectionLastSeen from './SectionLastSeen';
import SectionSocialsMaybe from './SectionSocialsMaybe';

import SectionFeaturesMaybe from './SectionFeaturesMaybe';
import SectionReviews from './SectionReviews';
import css from './ListingPage.module.css';
import SignupModal from '../../components/Topbar/SignupModal';

import { PrimaryButton } from '../../components';

import IGVerified from '../../../src/assets/Instagram Verified.png'


const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

export class ListingPageComponent extends Component {
  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      selectedPlan: 0,
      checkSignupModal: false,
      enableLoginModal: false,
      changeSignupModal: false,
      pendingAction: null,
      enquiriesPausedModalOpen: false,
      fastReplyPicks: [],
      pausedTesterNotified: false,
      enquiryAllowedForListingId: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onContactUser = this.onContactUser.bind(this);
    this.openEnquiriesPausedModal = this.openEnquiriesPausedModal.bind(this);
    this.onSubmitEnquiry = this.onSubmitEnquiry.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, currentUser } = this.props;
    const { pendingAction } = this.state;

    if (!pendingAction) return;

    if (pendingAction === 'enquiry' && isAuthenticated && !prevProps.isAuthenticated) {
      this.setState({
        enquiryModalOpen: true,
        enableLoginModal: false,
        checkSignupModal: false,
        pendingAction: null,
      });
    } else if (pendingAction === 'checkout' && isAuthenticated && currentUser) {
      this.setState({
        enableLoginModal: false,
        checkSignupModal: false,
        pendingAction: null,
      });
      this.handleSubmit({ selectedPlan: this.state.selectedPlan });
    }
  }

  handleSubmit(values) {
    const {
      history,
      getListing,
      params,
      callSetInitialValues,
      currentUser,
      onInitializeCardPaymentData,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);

    const { bookingStartTime, bookingEndTime, selectedPlan, ...restOfValues } = values || {};
    const bookingStart = timestampToDate(bookingStartTime);
    const bookingEnd = timestampToDate(bookingEndTime);
    const method = listing.attributes.publicData.prices[selectedPlan]?.method;

    // const bookingData = {
    //   quantity: calculateQuantityFromHours(bookingStart, bookingEnd),
    //   ...restOfValues,
    // };

    const initialValues = {
      listing,
      bookingData: {
        selectedPlan: selectedPlan,
        method: method,
      },
      bookingDates: {
        // bookingStart,
        // bookingEnd,
      },
      confirmPaymentError: null,
    };
    if (!currentUser) {
      const id = listing.id.uuid;
      const slug = createSlug(listing.attributes.title);
      const pathParams = { id, slug };
      history.push(
        createResourceLocatorString('ListingPage', routeConfiguration(), pathParams, {})
      );
      this.setState({ enableLoginModal: true, pendingAction: 'checkout' });
      return;
    }
    // Keep the checkout in this tab's sessionStorage as well, so the checkout
    // page can rebuild itself after a reload: a refresh, or Whop sending the
    // buyer back once they've paid.
    const saveToSessionStorage = true;

    // No Whop order is created here anymore. Like the Stripe flow, the
    // request-payment-whop transaction is created only when the buyer reaches the
    // Pay step on the CheckoutPage — so merely clicking "Book" (or landing on
    // checkout) never creates a phantom pending transaction / provider-inbox noise.

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
        {}
      )
    );
  }

  // A paused tester gets a "book or try someone else" modal instead of the enquiry
  // form, so customers aren't left waiting on a tester who isn't replying.
  openEnquiriesPausedModal() {
    const { onFetchFastReplyListings, params } = this.props;
    this.setState({ enquiriesPausedModalOpen: true, fastReplyPicks: [] });
    this.notifyPausedTester();

    const listingsPromise = this.fastReplyListings
      ? Promise.resolve(this.fastReplyListings)
      : onFetchFastReplyListings();

    listingsPromise.then(listings => {
      this.fastReplyListings = listings;
      const listingsById = listings.reduce((byId, l) => ({ ...byId, [l.id.uuid]: l }), {});
      const available = FAST_REPLY_TESTERS.filter(tester => {
        const listing = listingsById[tester.listingId];
        return tester.listingId !== params.id && listing && !isEnquiriesPaused(listing);
      }).map(tester => ({ ...tester, listing: listingsById[tester.listingId] }));
      this.setState({ fastReplyPicks: pickFastReplyTesters(available) });
    });
  }

  // Logged-out visitors can't start a transaction, so only logged-in customers
  // send the tester the automatic enquiry.
  notifyPausedTester() {
    const { currentUser, onSendEnquiry, params } = this.props;
    if (!currentUser) {
      this.setState({ pausedTesterNotified: false });
      return;
    }

    const customerId = currentUser.id.uuid;
    if (wasPausedEnquirySent(customerId, params.id)) {
      this.setState({ pausedTesterNotified: true });
      return;
    }

    rememberPausedEnquirySent(customerId, params.id);
    const { firstName, displayName } = currentUser.attributes.profile;
    onSendEnquiry(new UUID(params.id), pausedEnquiryMessage(firstName || displayName))
      .then(() => this.setState({ pausedTesterNotified: true }))
      .catch(() => {
        // Error is logged in the duck; let the next click try again.
        rememberPausedEnquirySent(customerId, params.id, 0);
      });
  }

  onContactUser() {
    const {
      currentUser,
      history,
      callSetInitialValues,
      params,
      location,
      getListing,
      onFetchHasBookedProvider,
    } = this.props;
    const listing = getListing(new UUID(params.id));
    if (isEnquiriesPaused(listing)) {
      const providerId = listing.author?.id?.uuid;
      if (!currentUser || !providerId) {
        this.openEnquiriesPausedModal();
        return;
      }
      // Someone who has booked this tester can still enquire as normal.
      onFetchHasBookedProvider(providerId).then(hasBooked => {
        if (hasBooked) {
          this.setState({ enquiryModalOpen: true, enquiryAllowedForListingId: params.id });
        } else {
          this.openEnquiriesPausedModal();
        }
      });
      return;
    }
    if (!currentUser) {
      const state = {
        from: `${location.pathname}${location.search}${location.hash}`,
        showModal: true,
      };
      this.setState({ checkSignupModal: true, pendingAction: 'enquiry' });
      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, { enquiryModalOpenForListingId: params.id });

      // signup and return back to listingPage.
      // history.push(createResourceLocatorString('SignupModal', routeConfiguration(), {}, {}), state);
    } else {
      this.setState({ enquiryModalOpen: true });
    }
  }

  onSubmitEnquiry(values) {
    const { history, params, onSendEnquiry } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const { message } = values;

    onSendEnquiry(listingId, message.trim())
      .then(txId => {
        this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  render() {
    const {
      unitType,
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      onManageDisableScrolling,
      onFetchTimeSlots,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      reviews,
      fetchReviewsError,
      sendEnquiryInProgress,
      sendEnquiryError,
      monthlyTimeSlots,
      filterConfig,
      onFetchTransactionLineItems,
      lineItems,
      fetchLineItemsInProgress,
      fetchLineItemsError,
      loginModal,
      loginModalState,
      signupModalState,
      signupModal,
    } = this.props;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };

    const listingType = isDraftVariant
      ? LISTING_PAGE_PARAM_TYPE_DRAFT
      : LISTING_PAGE_PARAM_TYPE_EDIT;
    const listingTab = isDraftVariant ? 'photos' : 'description';

    const isApproved =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      (isPendingApprovalVariant || isDraftVariant) &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const {
      description = '',
      geolocation = null,
      price = null,
      title = '',
      publicData,
      metadata,
    } = currentListing.attributes;
    const { dob } = publicData;
    const dateOfBirth = moment(dob, 'YYYY-MM-DD');
    const exactAge = dateOfBirth
      ? parseInt(moment.duration(moment().diff(dateOfBirth)).asYears(), 10)
      : null;
    const ageRange = getAgeRange(exactAge);

    const hasInstagram = currentListing?.author?.attributes?.profile?.metadata?.instagram;
    // Testers in the search order get the check even without an Instagram handle.
    // The Instagram section further down still only appears once a handle is added.
    const showVerifiedCheck =
      hasInstagram || config.custom.searchProfilePriorityUUIDs.includes(listingId.uuid);
 
    const richTitle = (
      <span className={css.titleWrapper}>
        <span className={css.titleText}>
          {richText(title, {
            longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
            longWordClass: css.longWord,
          })}
          
          {showVerifiedCheck &&
            <img 
            src={IGVerified} 
            alt="Instagram Verified" 
            style={{ 
              height: '0.75em',
              marginLeft: '4px',
              alignSelf: 'center'
            }} 
          />
        } {/* IG Verified Icon */}
        </span>
        {ageRange && (
          <span className={css.ageBadgeProfile}>
            <FaBirthdayCake className={css.cakeIcon} />
            {ageRange}
          </span>
        )}
      </span>
    );
    // console.log({ publicData });
    const bookingTitle = (
      <FormattedMessage id="ListingPage.bookingTitle" values={{ title: richTitle }} />
    );

    const topbar = <TopbarContainer currentPage="ListingPage" />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} hideCookieConsent scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} hideCookieConsent scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const handleViewPhotosClick = e => {
      // Stop event from bubbling up to prevent image click handler
      // trying to open the carousel as well.
      e.stopPropagation();
      this.setState({
        imageCarouselOpen: true,
      });
    };
    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing));

    const enquiriesPaused = isEnquiriesPaused(currentListing);

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const handleBookingSubmit = values => {
      const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
      if (isOwnListing || isCurrentlyClosed) {
        window.scrollTo(0, 0);
      } else {
        this.handleSubmit(values);
      }
    };

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'facebook');
    const twitterImages = listingImages(currentListing, 'twitter');
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ListingPage.schemaTitle' },
      { title, price: formattedPrice, siteTitle }
    );
    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const yogaStylesOptions = findOptionsForSelectFilter('yogaStyles', filterConfig);
    const certificateOptions = findOptionsForSelectFilter('certificate', filterConfig);
    const setModalState = data => {
      if (data === false) {
        this.setState({ checkSignupModal: false, enableLoginModal: true });
      }
    };

    const selectedMobilePlan = this.state.selectedPlan ?? 0;
    const activeMobilePrice = publicData?.prices?.[selectedMobilePlan];
    const activeMobilePriceFormatted = activeMobilePrice
      ? formatMoney(intl, new sdkTypes.Money(activeMobilePrice.price, config.currency))
      : formattedPrice;

    return (
      <Page
        title={schemaTitle}
        hideCookieConsent
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        contentType="website"
        description={description}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ItemPage',
          description: description,
          name: schemaTitle,
          image: schemaImages,
        }}
      >
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div>
              {isOwnListing && enquiriesPaused ? (
                <p className={css.ownEnquiriesPausedNotice}>
                  Enquiries are turned off, so customers can only book you.{' '}
                  <NamedLink name="EnquirySettingsPage">Turn enquiries back on</NamedLink>
                </p>
              ) : null}

              {/* Action bar for own listings */}
              <SectionImages
                title={title}
                listing={currentListing}
                isOwnListing={isOwnListing}
                editParams={{
                  id: listingId.uuid,
                  slug: listingSlug,
                  type: listingType,
                  tab: listingTab,
                }}
                imageCarouselOpen={this.state.imageCarouselOpen}
                onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                handleViewPhotosClick={handleViewPhotosClick}
                onManageDisableScrolling={onManageDisableScrolling}
              />

              {/* Mobile-only: photo carousel then name */}
              <div className={css.mobileOnlyPhotos}>
                <SectionPhotosMaybe
                  listing={currentListing}
                  isOwnListing={isOwnListing}
                  editParams={{
                    id: listingId.uuid,
                    slug: listingSlug,
                    type: listingType,
                    tab: listingTab,
                  }}
                  title={title}
                  imageCarouselOpen={this.state.imageCarouselOpen}
                  onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                  handleViewPhotosClick={handleViewPhotosClick}
                  onManageDisableScrolling={onManageDisableScrolling}
                />
                <div className={css.mobileHeadingRow}>
                  <SectionAvatar user={currentAuthor} listing={currentListing} params={params} />
                  <SectionHeading
                    priceTitle={priceTitle}
                    formattedPrice={formattedPrice}
                    richTitle={richTitle}
                    publicData={publicData}
                    metadata={metadata}
                    certificateOptions={certificateOptions}
                    hostLink={hostLink}
                    showContactUser={showContactUser}
                    onContactUser={this.onContactUser}
                    onBookingSubmit={handleBookingSubmit}
                    selectedPlan={this.state.selectedPlan}
                  />
                  <SectionLastSeen lastSeenAt={metadata?.lastSeenAt} />
                </div>

                <div className={css.mobilePricing}>
                  <SectionPricingMaybe
                    publicData={publicData}
                    onBookingSubmit={handleBookingSubmit}
                    intl={intl}
                    description={description}
                    setSelectedPlan={plan => this.setState({ selectedPlan: plan })}
                    selectedPlan={this.state.selectedPlan}
                    showContactUser={showContactUser}
                    onContactUser={this.onContactUser}
                  />
                </div>

                <div className={css.mobileAbout}>
                  <SectionDescriptionMaybe publicData={publicData} description={description} />
                  <SectionSocialsMaybe
                    currentUser={currentUser}
                    instagram={
                      currentListing?.author?.attributes?.profile?.metadata?.instagram || ''
                    }
                    publicData={publicData}
                    description={description}
                  />
                </div>

                <div className={css.mobileReviews}>
                  <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} />
                </div>
              </div>

              {/* Two-column: left = heading + photos + info, right = sticky panel */}
              <div className={css.contentContainer}>
                <div className={css.mainContent}>
                  <div className={css.desktopHeadingRow}>
                    <SectionAvatar user={currentAuthor} listing={currentListing} params={params} />
                    <SectionHeading
                      priceTitle={priceTitle}
                      formattedPrice={formattedPrice}
                      richTitle={richTitle}
                      publicData={publicData}
                      metadata={metadata}
                      certificateOptions={certificateOptions}
                      hostLink={hostLink}
                      showContactUser={showContactUser}
                      onContactUser={this.onContactUser}
                      onBookingSubmit={handleBookingSubmit}
                      selectedPlan={this.state.selectedPlan}
                    />
                    <SectionLastSeen lastSeenAt={metadata?.lastSeenAt} />
                  </div>

                  <div className={css.desktopOnlyPhotos}>
                    <SectionPhotosMaybe
                      listing={currentListing}
                      isOwnListing={isOwnListing}
                      editParams={{
                        id: listingId.uuid,
                        slug: listingSlug,
                        type: listingType,
                        tab: listingTab,
                      }}
                      title={title}
                      imageCarouselOpen={this.state.imageCarouselOpen}
                      onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                      handleViewPhotosClick={handleViewPhotosClick}
                      onManageDisableScrolling={onManageDisableScrolling}
                    />
                  </div>

                  <div className={css.desktopOnlyContent}>
                    <SectionDescriptionMaybe publicData={publicData} description={description} />

                    <SectionSocialsMaybe
                      currentUser={currentUser}
                      instagram={
                        currentListing?.author?.attributes?.profile?.metadata?.instagram || ''
                      }
                      publicData={publicData}
                      description={description}
                    />

                    <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} />
                  </div>
                </div>

                <div className={css.sidebarColumn}>
                  <SectionPricingMaybe
                    publicData={publicData}
                    onBookingSubmit={handleBookingSubmit}
                    intl={intl}
                    description={description}
                    setSelectedPlan={plan => this.setState({ selectedPlan: plan })}
                    selectedPlan={this.state.selectedPlan}
                    showContactUser={showContactUser}
                    onContactUser={this.onContactUser}
                  />
                </div>
              </div>
            </div>

            {/* Mobile sticky bottom bar */}
            {activeMobilePrice && (
              <div className={css.mobileBottomBar}>
                <button
                  type="button"
                  className={css.mobileBottomBtn}
                  onClick={() => handleBookingSubmit({ selectedPlan: selectedMobilePlan })}
                >
                  Continue
                </button>
                <div className={css.mobileBottomPrice}>
                  <span className={css.mobileBottomAmount}>{activeMobilePriceFormatted}</span>
                </div>
              </div>
            )}

            <Modal
              isAuth={true}
              id="AuthenticationPageLogin.tos"
              isOpen={
                isAuthenticated
                  ? null
                  : this.state.enableLoginModal && !signupModalState?.signupModal
              }
              onClose={() => {
                this.setState({ enableLoginModal: false, pendingAction: null });
                loginModal({ loginModal: false });
              }}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <AuthenticationPage type="login" />
            </Modal>

            <Modal
              id="ListingPage.enquiry"
              contentClassName={css.enquiryModalContent}
              isOpen={
                isAuthenticated &&
                this.state.enquiryModalOpen &&
                (!enquiriesPaused || this.state.enquiryAllowedForListingId === rawParams.id)
              }
              onClose={() => this.setState({ enquiryModalOpen: false })}
              onManageDisableScrolling={onManageDisableScrolling}
              usePortal
            >
              <EnquiryForm
                className={css.enquiryForm}
                submitButtonWrapperClassName={css.enquirySubmitButtonWrapper}
                listingTitle={activeMobilePrice?.title || title}
                authorDisplayName={authorDisplayName}
                sendEnquiryError={sendEnquiryError}
                onSubmit={this.onSubmitEnquiry}
                inProgress={sendEnquiryInProgress}
              />
            </Modal>

            <Modal
              id="ListingPage.enquiriesPaused"
              contentClassName={css.enquiryModalContent}
              isOpen={this.state.enquiriesPausedModalOpen}
              onClose={() => this.setState({ enquiriesPausedModalOpen: false })}
              onManageDisableScrolling={onManageDisableScrolling}
              usePortal
            >
              <SectionEnquiriesPaused
                authorDisplayName={authorDisplayName}
                picks={this.state.fastReplyPicks}
                testerNotified={this.state.pausedTesterNotified}
                intl={intl}
                onBook={() => {
                  this.setState({ enquiriesPausedModalOpen: false });
                  handleBookingSubmit({ selectedPlan: this.state.selectedPlan });
                }}
                onPickClick={() => this.setState({ enquiriesPausedModalOpen: false })}
              />
            </Modal>
            {this.state.checkSignupModal ? (
              <SignupModal
                currentState={this.state.checkSignupModal}
                data={setModalState}
                onDismiss={() => this.setState({ pendingAction: null })}
              />
            ) : null}
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: null,
  sendEnquiryError: null,
  filterConfig: config.custom.filters,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  enquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  monthlyTimeSlots: object,
  // monthlyTimeSlots could be something like:
  // monthlyTimeSlots: {
  //   '2019-11': {
  //     timeSlots: [],
  //     fetchTimeSlotsInProgress: false,
  //     fetchTimeSlotsError: null,
  //   }
  // }
  sendEnquiryInProgress: bool.isRequired,
  sendEnquiryError: propTypes.error,
  onSendEnquiry: func.isRequired,
  onFetchFastReplyListings: func.isRequired,
  onFetchHasBookedProvider: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  filterConfig: array,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated, loginModal, signupModal } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendEnquiryInProgress,
    sendEnquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    enquiryModalOpenForListingId,
  } = state.ListingPage;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    loginModalState: loginModal,
    signupModalState: signupModal,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendEnquiryInProgress,
    sendEnquiryError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: (bookingData, listingId, isOwnListing) =>
    dispatch(fetchTransactionLineItems(bookingData, listingId, isOwnListing)),
  onSendEnquiry: (listingId, message) => dispatch(sendEnquiry(listingId, message)),
  onFetchFastReplyListings: () => dispatch(fetchFastReplyListings()),
  onFetchHasBookedProvider: providerId => dispatch(fetchHasBookedProvider(providerId)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onInitiateOrder: params => dispatch(initiateOrder(params)),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  loginModal: value => dispatch(loginModalDispatch(value)),
  signupModal: value => dispatch(signupModalDispatch(value)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ListingPageComponent);

export default ListingPage;
